import React, { useState } from 'react'
import './DashboardNavigation.css'
import dashboardIcon from '../../../../assets/images/dashboard-white.png'
import auctionIcon from '../../../../assets/images/auction-list-icon-white.png'
import paymentIcon from '../../../../assets/images/auction-payment-icon-white.png'
import assetsIcon from '../../../../assets/images/asset-icon-white.png'
import bidderIcon from '../../../../assets/images/agreement-icon-white.png'
import bulkIcon from '../../../../assets/images/bulk-icon-white.png'
import callbackIcon from '../../../../assets/images/call-back-icon-white.png'
import demoIcon from '../../../../assets/images/demo-icon-white.png'
import enquiryIcon from '../../../../assets/images/enquiry-icon-white.png'
import tradesIcon from '../../../../assets/images/trade-icon-white.png'
import instaIcon from '../../../../assets/images/insta-icon-white.png'
import advancedIcon from '../../../../assets/images/advance-icon-white.png'
import profileIcon from '../../../../assets/images/profile-icon-white.png'
import agreementsIcon from '../../../../assets/images/agreement-icon-white.png'
import transactionsIcon from '../../../../assets/images/transection-icon-white.png'
import watchlistIcon from '../../../../assets/images/watchlist-icon-white.png'
import passwordIcon from '../../../../assets/images/password-icon-white.png'
import dashboardIconBlack from '../../../../assets/images/dashboard-black.png'
import auctionIconBlack from '../../../../assets/images/auction-list-icon-black.png'
import paymentIconBlack from '../../../../assets/images/auction-payment-icon-black.png'
import assetsIconBlack from '../../../../assets/images/asset-icon-black.png'
import bidderIconBlack from '../../../../assets/images/agreement-icon-black.png'
import bulkIconBlack from '../../../../assets/images/bulk-icon-black.png'
import callbackIconBlack from '../../../../assets/images/call-back-icon-black.png'
import demoIconBlack from '../../../../assets/images/demo-icon-black.png'
import enquiryIconBlack from '../../../../assets/images/enquiry-icon-black.png'
import tradesIconBlack from '../../../../assets/images/trade-icon-black.png'
import instaIconBlack from '../../../../assets/images/insta-icon-black.png'
import advancedIconBlack from '../../../../assets/images/advance-icon-black.png'
import profileIconBlack from '../../../../assets/images/profile-icon-black.png'
import agreementsIconBlack from '../../../../assets/images/agreement-icon-black.png'
import transactionsIconBlack from '../../../../assets/images/transection-icon-black.png'
import watchlistIconBlack from '../../../../assets/images/watchlist-icon-black.png'
import passwordIconBlack from '../../../../assets/images/password-icon-black.png'

import { ExpandMore } from '@material-ui/icons'
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Card,
    CardContent,
    Grid,
    Typography,
} from '@material-ui/core'
import { handleRedirectInternal } from '@/custom/common/components'
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min'

const DashboardNavigation = () => {
    const [expanded, setExpanded] = useState(false)
    const history = useHistory()
    const location = useLocation()

    const sections = [
        {
            title: 'Dashboard',
            icon: dashboardIcon,
            iconblack: dashboardIconBlack,
            path: 'account/dashboard',
        },

        {
            title: 'Auction Payment History',
            icon: paymentIcon,
            iconblack: paymentIconBlack,
            path: 'payments/emd',
        },
        {
            title: 'Auctions Fullfillment List',
            icon: auctionIcon,
            iconblack: auctionIconBlack,
            path: 'invoices/all',
        },
        // {
        //     title: 'Assets',
        //     icon: assetsIcon,
        //     iconblack: assetsIconBlack,
        //     path: 'bidderSign',
        // },
        {
            title: 'Bidder Undertaking',
            icon: bidderIcon,
            iconblack: bidderIconBlack,
            path: 'bidderSign',
        },
        // {
        //     title: 'Bulk Uploads',
        //     icon: bulkIcon,
        //     iconblack: bulkIconBlack,
        //     path: 'account/bulkuploads',
        // },
        {
            title: 'Call Back Requests',
            icon: callbackIcon,
            iconblack: callbackIconBlack,
            path: 'callback',
        },

        // {
        //     title: 'Enquiries',
        //     icon: enquiryIcon,
        //     iconblack: enquiryIconBlack,
        //     path: 'account/enquiries',
        // },
        // { title: 'Trades', icon: tradesIcon, iconblack: tradesIconBlack, path: 'account/trades' },
        // {
        //     title: 'Instagram Posts',
        //     icon: instaIcon,
        //     iconblack: instaIconBlack,
        //     path: 'account/instaposts',
        // },
        // {
        //     title: 'Advanced Search',
        //     icon: advancedIcon,
        //     iconblack: advancedIconBlack,
        //     path: 'account/advancedsearch',
        // },
        {
            title: 'Profile',
            icon: profileIcon,
            iconblack: profileIconBlack,
            path: 'account/profile',
        },
        {
            title: 'Change Password',
            icon: passwordIcon,
            iconblack: passwordIconBlack,
            path: 'account/change',
        },
        {
            title: 'My Agreements',
            icon: agreementsIcon,
            iconblack: agreementsIconBlack,
            path: 'my_agreements',
        },
        {
            title: 'Transactions',
            icon: transactionsIcon,
            iconblack: transactionsIconBlack,
            path: 'transactions',
        },
        {
            title: 'My Bids',
            icon: auctionIcon,
            iconblack: auctionIconBlack,
            path: 'auctions/winning',
        },
        {
            title: 'My Watchlist',
            icon: watchlistIcon,
            iconblack: watchlistIconBlack,
            path: 'watchlist/watchlist',
        },
    ]
    const activeSection = sections.find((section) => location.pathname === '/' + section.path)

    return (
        <>
            <Accordion
                expanded={expanded}
                onChange={() => setExpanded(!expanded)}
                className="dashboard-accordion m-0"
            >
                <AccordionSummary
                    style={{ height: 'auto', maxHeight: '35px' }}
                    expandIcon={<ExpandMore />}
                >
                    <CardContent style={{ padding: '0' }}>
                        <Typography
                            variant="h6"
                            style={{ textAlign: 'left', fontSize: '16px', padding: '5px' }}
                            component="div"
                        >
                            Menu
                        </Typography>
                    </CardContent>
                </AccordionSummary>
                <AccordionDetails style={{ padding: '5px' }}>
                    <Grid container spacing={1}>
                        {sections.map((section) => (
                            <Grid item xs={6} sm={6} md={4} key={section.title}>
                                <Card
                                    className={`dashboard-card ${
                                        activeSection?.title === section.title ? 'active' : ''
                                    }`}
                                    onClick={() => handleRedirectInternal(history, section.path)}
                                >
                                    <CardContent>
                                        <img
                                            src={
                                                activeSection?.title === section.title
                                                    ? section.icon
                                                    : section.iconblack
                                            }
                                            alt={`${section.title} icon`}
                                            style={{ width: '40px' }}
                                        />
                                        <Typography
                                            variant="h6"
                                            style={{ fontSize: '10px', marginTop: '5px' }}
                                            component="div"
                                        >
                                            {section.title}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </AccordionDetails>
            </Accordion>
        </>
    )
}

export default DashboardNavigation
